module.exports = __webpack_public_path__ + "img/logoLight.7cbd42df.png";